<template>
  <div id="app">
    <img src="./assets/logo.png" class="icon">
    <h2>
      欢迎来到创之道网络科技公司
    </h2>
    <HelloWorld msg="Welcome"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.icon{
  width: 300px;
}
</style>
